import type { LoginProfilePayload, LoginResponsePayload } from '@/store/types'

/** Drops the session credentials so only the profile is kept in app state. */
export const stripSessionTokens = ({
  token: _token,
  refresh_token: _refreshToken,
  token_expiration: _tokenExpiration,
  ...profile
}: LoginResponsePayload): LoginProfilePayload => profile
